import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
    AlertController,
    ModalController,
    Platform,
} from '@ionic/angular';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { WizardStep } from '../../../../shared/state/wizard-step/wizard-step.model';
import { TreatmentWizardSettingsState } from '../../../../shared/state/treatment-wizard-settings/treatment-wizard-settings.store';
import { IdsStepsTreatmentWizardModel } from '../../../../shared/models/idsStepsTreatmentWizard.model';
import { WizardStepQuery } from '../../../../shared/state/wizard-step/wizard-step-query';
import { TreatmentWizardSettingsQuery } from '../../../../shared/state/treatment-wizard-settings/treatment-wizard-settings.query';
import { TreatmentWizardSettingsService } from '../../../../shared/state/treatment-wizard-settings/treatment-wizard-settings.service';
import { WizardStepService } from '../../../../shared/state/wizard-step/wizard-step.service';
import { ProductWizardService } from '../../../../shared/state/product-wizard/product-wizard.service';
import { FamilyWizardModel } from '../../../../shared/models/family-wizard.model';
import { ProductWizardQuery } from '../../../../shared/state/product-wizard/product-wizard.query';
import {
    ProductWizard,
    ProductWizardCheckedEvent,
} from '../../../../shared/state/product-wizard/product-wizard.model';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { ProductViewComponent } from '../../components/product-view/product-view.component';
import {
    PaymethodWizard,
    PaymethodWizardCheckedEvent,
} from '../../../../shared/state/paymethod-wizard/paymethod-wizard.model';
import { PaymethodWizardQuery } from '../../../../shared/state/paymethod-wizard/paymethod-wizard.query';
import { PaymethodWizardService } from '../../../../shared/state/paymethod-wizard/paymethod-wizard.service';
import { PaymentWizardSettingsService } from '../../../../shared/state/payment-wizard-settings/payment-wizard-settings.service';
import { PaymentWizardSettingsQuery } from '../../../../shared/state/payment-wizard-settings/payment-wizard-settings.query';
import { LibraryService } from '../../../../core/services/library/library.service';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { ShippingConfigComponent } from '../../components/shipping-config/shipping-config.component';
import { TreatmentService } from '../../../../shared/state/treatment/treatment.service';
import { UserService } from '../../../../shared/state/user/user.service';
import { LoadingService } from '../../../../shared/state/loading/loading.service';
import { KeyboardQuery } from '../../../../shared/state/keyboard/keyboard.query';
import { ClinicDetailQuery } from '../../../../shared/state/clinic-detail/clinic-detail.query';
import { RouterService } from '../../../../core/services/router/router.service';
import { FamilyFolderModel } from '../../../../shared/models/family-folder.model';
import { ServiceSearchbarComponent } from '../../../../shared/components/service-searchbar/service-searchbar.component';
import { GenericHeaderComponent } from '../../../../shared/components/generic-header/generic-header.component';
import { IdsStepsAppointmentWizardModel } from '../../../../shared/models/idsStepsAppointmentWizard.model';
import {
    templatePayMethodStepCheckShowActionButton,
    templatePaymethodsActionButtonDisabled,
    templatePaymethodUndoNextStep,
    templateResultStepCheckShowActionButton,
    stepsLabels
} from './treatment-wizard.functions';
import { HeaderPictureQuery } from 'src/app/shared/state/header-picture/header-picture.query';
import { CompanyQuery } from 'src/app/shared/state/company/company.query';
import Swiper from 'swiper';

@Component({
    selector: 'app-treatment-wizard',
    templateUrl: './treatment-wizard.component.html',
    styleUrls: ['./treatment-wizard.component.scss'],
})

/** TODO: Animaciones en los checkboxes
 * UPDATE 22/3/2021: Es por como relleno yo el ckechbox (si lo dejas sin ngmodel sique aparece la animación) */

//TODO: Revisar tanto aqui como en el de tratamientos, que la primera pagina de familia, se recarga al marcar un checkbox y da mala sensacion, pasa igual en default y 360
export class TreatmentWizardComponent implements OnInit, OnDestroy {
    appDelegate$: Observable<boolean>;
    familiesWizard$: Observable<FamilyWizardModel[]>;
    familiesFilterWizard$: Observable<FamilyWizardModel[]>;
    slideOpts = {};
    disabledButtonAction$: Observable<boolean>;
    labelButtonAction$: Observable<string>;
    showActionButton$: Observable<boolean>;
    treatmentWizardSettings$: Observable<TreatmentWizardSettingsState>;
    stepActive$: Observable<WizardStep>;
    slideActiveIndex: number;
    productsWizardFamily$: Observable<ProductWizard[]>;
    productsWizard$: Observable<ProductWizard[]>;
    /** Servicios filtrados por familias */
    productsWithUnits$: Observable<ProductWizard[]>;
    /** Servicios seleccionados por el usuario */
    paymethodsWizard$: Observable<PaymethodWizard[]>;
    paymethodsChecked$: Observable<PaymethodWizard[]>;
    urlPaymentSafe$: Observable<any>;
    listenerEventsPayment;
    shippingEnabled$: Observable<number>;
    keyboardIsShowing: Observable<boolean>;
    isLoadingContent;
    productsLength;
    familyFolderTree: FamilyFolderModel;
    familyFolderSlide: FamilyFolderModel[] = [];
    familyFolderSlideFiltered: FamilyFolderModel[] = [];
    idsStepsTreatmentWizardModel = IdsStepsTreatmentWizardModel;
    headerCurrentStep = 0;

    /** Flowwwer template */
    clinicName$: Observable<string>;
    logoHeader: string = null;
    familyFolderUserAction$ = new Subject<boolean>();

    @ViewChild(GenericHeaderComponent) genericHeader: GenericHeaderComponent;
    @ViewChild(ShippingConfigComponent, { static: false })
    shippingConfigConponent: ShippingConfigComponent;
    @ViewChild(ServiceSearchbarComponent)
    serviceSearchBar: ServiceSearchbarComponent;
    @ViewChild('swiper') swiperContainer?: ElementRef;

    /** 1º Introducimos todos los pasos del asistente en el Store */
    appointmentWizardSteps: WizardStep[] = [
        {
            id: IdsStepsTreatmentWizardModel.FAMILIES,
            titleLabel: stepsLabels.FAMILIES,
            actionLabel: 'app_ask_sched_step_1_button',
            showActionButton: true,
        },
        {
            id: IdsStepsTreatmentWizardModel.PAYMETHODS,
            titleLabel: stepsLabels.PAYMETHODS,
            actionLabel: 'app_ask_sched_step_1_button',
            showActionButton: true,
        },
        {
            id: IdsStepsTreatmentWizardModel.PAYMENT,
            titleLabel: stepsLabels.PAYMENT,
            actionLabel: '',
            showActionButton: false,
        },
        {
            id: IdsStepsTreatmentWizardModel.RESULT,
            titleLabel: stepsLabels.RESULT,
            actionLabel: 'lbl_treatments_see',
            showActionButton: false,
        },
    ];

    constructor(
        private modalController: ModalController,
        private wizardStepQuery: WizardStepQuery,
        private wizardStepService: WizardStepService,
        private treatmentWizardSettingsQuery: TreatmentWizardSettingsQuery,
        private treatmentWizardSettingsService: TreatmentWizardSettingsService,
        private productWizardService: ProductWizardService,
        private productWizardQuery: ProductWizardQuery,
        private paymethodWizardQuery: PaymethodWizardQuery,
        private paymethodWizardService: PaymethodWizardService,
        private paymentWizardSettingsService: PaymentWizardSettingsService,
        private paymentWizardSettingsQuery: PaymentWizardSettingsQuery,
        private libraryService: LibraryService,
        private settingsQuery: SettingsQuery,
        private treatmentService: TreatmentService,
        private alertCtrl: AlertController,
        private platform: Platform,
        private ngZone: NgZone,
        private userService: UserService,
        private loadingService: LoadingService,
        private keyboardQuery: KeyboardQuery,
        private routerService: RouterService,
        private clinicDetailQuery: ClinicDetailQuery,
        private headerPicturesQuery: HeaderPictureQuery,
        private companyQuery: CompanyQuery
    ) {}

    ngOnInit(): void {
        this.appDelegate$ = this.clinicDetailQuery.select('appDelegate');
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        this.isLoadingContent = true;
    }

    async ngAfterViewInit() {
        try {
            await this.initWizardConfig();
        } catch (error) {
            this.isLoadingContent = false;
        }
        this.isLoadingContent = false;

        this.stepActive$.subscribe((step) => {
            if (step) {
                if (step.id < IdsStepsTreatmentWizardModel.PAYMETHODS) {
                    this.headerCurrentStep = 0;
                } else if (step.id < IdsStepsTreatmentWizardModel.PAYMENT) {
                    this.headerCurrentStep = 1;
                } else {
                    this.headerCurrentStep = 2;
                }
            }
        });

        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
        this.headerPicturesQuery
            .select('homeCompany')
            .subscribe((homeCompany) => {
                this.logoHeader = homeCompany;
            });
    }

    goBack(): void {
        const { stepStack } = this.treatmentWizardSettingsQuery.getValue();
        const currentStep: WizardStep = this.wizardStepQuery.getActive();

        if (currentStep?.id === IdsStepsAppointmentWizardModel.RESULT) {
            this.dismissModal();
            return;
        }

        if (
            currentStep?.id === IdsStepsAppointmentWizardModel.FAMILIES &&
            this.slideActiveIndex > 0
        ) {
            this.popFamilyFolder();
            return;
        }

        if (stepStack?.length > 0) {
            this.goToPrevStep();
            return;
        }

        this.dismissModal();
    }

    ionViewDidEnter() {
        this.swiperContainer?.nativeElement.swiper.update();
    }

    dismissModal() {
        this.modalController.dismiss({
            dismissed: true,
        });
    }

    /*-----------------------------*/
    /** FUNCIONES GENÉRICAS WIZARD */

    /*-----------------------------*/

    /** Función que inicializa el primera paso. No hay que hacer el avance con slide porque aun no está el objeto creado y se inicia solo */
    goToInitStep(initStep: WizardStep) {
        /** 1º Inicializamos el paso siguiente */
        this.initNextStep(initStep);

        /** 2º Avanzamos al paso siguiente */
        this.goToStep(initStep);
    }

    /** Función que retrocede de un paso a otro */
    goToPrevStep() {
        /** 1º Hace los cambios necesarios al destruir un paso y volver atrás */
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        this.destroyCurrentStep(currentStep);

        /** 2º Retrocede al paso anterior, buscando en la pila de pasos */
        const prevStep: WizardStep = this.wizardStepQuery.getEntity(
            this.treatmentWizardSettingsQuery.stepStack[
                this.treatmentWizardSettingsQuery.stepStack.length - 1
            ]
        );
        this.undoNextStep(prevStep);
        this.goToStep(prevStep);

        /** 3º Saca el paso que vamos a dejar atrás de la pila */
        this.treatmentWizardSettingsService.popStepStack();
    }

    /** Función que inicializa uno de los pasos */
    destroyCurrentStep(currentStep: WizardStep) {
        switch (currentStep.id) {
            case IdsStepsTreatmentWizardModel.FAMILIES: {
                this.destroyFamilyStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMETHODS: {
                this.destroyPaymethodStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMENT: {
                this.destroyPaymentStep();
                break;
            }
        }
    }

    /** Función que avanza de un paso a otro */
    goToNextStep(nextStepId: number, addCurrentStepToStak = true) {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        /** 1º En la pila de pasos, añade el paso que vamos a dejar atrás */
        if (addCurrentStepToStak) {
            this.treatmentWizardSettingsService.pushStepStack(currentStep.id);
        }

        /** 2º Inicializamos el paso siguiente */
        const nextStep: WizardStep = this.wizardStepQuery.getEntity(nextStepId);
        this.initNextStep(nextStep);

        /** 3º Avanzamos al paso siguiente */
        this.goToStep(nextStep);
    }

    /** Función que inicializa uno de los pasos */
    initNextStep(nextStep: WizardStep) {
        switch (nextStep.id) {
            case IdsStepsTreatmentWizardModel.FAMILIES: {
                this.initFamilyStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMETHODS: {
                this.initPaymethodStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMENT: {
                this.initPaymentStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.RESULT: {
                this.initResultStep();
                break;
            }
        }
    }

    /** Función que avanza al paso siguiente */
    goToStep(step: WizardStep) {
        /** 1º Se mueve al paso siguiente con la librería de slides */
        this.swiperContainer?.nativeElement.swiper.slideTo(step.id);

        /** 2º Actualiza el paso activo actual */
        this.wizardStepService.setActive(step.id.toString());

        /** 3º Actualiza el disabled del botón de acción según el paso y su label */
        this.checkShowActionButton();
        this.getLabelActionButton();
        this.checkDisabledButtonAction();
    }

    /** Cuando se pulsa el botón de continuar (si lo hay), se llama a la función de next step  de los pasos */
    actionNextStep() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsTreatmentWizardModel.FAMILIES: {
                this.familyNextStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMETHODS: {
                this.paymethodNextStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMENT: {
                this.paymentNextStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.RESULT: {
                this.resultNextStep();
                break;
            }
        }
    }

    undoNextStep(step: WizardStep) {
        switch (step.id) {
            case IdsStepsTreatmentWizardModel.FAMILIES: {
                this.familyUndoNextStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMETHODS: {
                this.paymethodUndoNextStep();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMENT: {
                this.paymentUndoNextStep();
                break;
            }
        }
    }

    /*--------------------------------------*/
    /** CONFIGURACIÓN DISABLED BOTÓN ACCIÓN */

    /*--------------------------------------*/

    checkDisabledButtonAction() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsTreatmentWizardModel.FAMILIES: {
                this.disabledButtonAction$ = this.familyActionButtonDisabled();
                break;
            }
            case IdsStepsTreatmentWizardModel.PAYMETHODS: {
                this.disabledButtonAction$ = this.paymethodsActionButtonDisabled();
                break;
            }
            case IdsStepsTreatmentWizardModel.RESULT: {
                this.disabledButtonAction$ = of(false);
                break;
            }
            default:
                this.disabledButtonAction$ = of(true);
                break;
        }
    }

    /*--------------------------------------*/
    /** LABEL PARA EL BOTÓN DE BOTÓN ACCIÓN */

    /*--------------------------------------*/

    getLabelActionButton() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            default:
                this.labelButtonAction$ = of(currentStep.actionLabel);
                break;
        }
    }

    /*--------------------------------------*/
    /** MOSTRAR O NO EL BOTÓN DE ACCIÓN */

    /*--------------------------------------*/

    checkShowActionButton() {
        const currentStep: WizardStep = this.wizardStepQuery.getActive();
        switch (currentStep.id) {
            case IdsStepsTreatmentWizardModel.PAYMETHODS:
                this.showActionButton$ = this.payMethodStepCheckShowActionButton();
                break;
            case IdsStepsTreatmentWizardModel.RESULT:
                this.showActionButton$ = this.resultStepCheckShowActionButton();
                break;
            default:
                this.showActionButton$ = of(currentStep.showActionButton);
                break;
        }
    }

    /*------------------------*/
    /** CONFIGURACIÓN PASO 0  */

    /*------------------------*/

    /** Configuración inicial del asistente. Definimos cual es el primer paso y su primer título */
    async initWizardConfig() {
        
        this.slideOpts = {
            speed: 200,
            allowTouchMove: false,
        };

        Object.assign(this.swiperContainer?.nativeElement, this.slideOpts);

        this.wizardStepService.setWizardSteps(this.appointmentWizardSteps);
        this.stepActive$ = this.wizardStepQuery.selectActive();

        /** Cargamos la configuración inicial del asistente de pedir cita */
        this.treatmentWizardSettings$ = this.treatmentWizardSettingsQuery.select();

        /** Obtenemos las familias sin duplicar (desarrollo de centros delegados) */
        this.familiesWizard$ = this.treatmentWizardSettingsQuery.selectFamiliesDistinct;

        /** Obtenemos los productos */
        this.productsWizard$ = this.productWizardQuery.selectAll();

        /** Juntamos el paso 0 (Familias) y 1 (Productos) (desarrollo de folder families) */
        this.treatmentWizardSettingsQuery
            .selectFamilyFolderTree(
                this.familiesWizard$,
                of([]),
                this.productsWizard$,
                of([])
            ).pipe(
                takeUntil(this.familyFolderUserAction$)
            )
            .subscribe((familyFolderRoot) => {
                this.familyFolderTree = familyFolderRoot;

                this.familyFolderSlide[0] = { ...this.familyFolderTree };
                this.familyFolderSlideFiltered[0] = {
                    ...this.familyFolderTree,
                };

                if (this.serviceSearchBar) {
                    this.onChangeFamilySearchbar(
                        this.serviceSearchBar.searchBar.value
                    );
                }
            });

        this.shippingEnabled$ = this.treatmentWizardSettingsQuery.select(
            'shippingEnabled'
        );
        this.loadingService.updateShowSpinner(true);
        await this.treatmentWizardSettingsService.getTreatmentWizardSettings();
        this.loadingService.updateShowSpinner(false);

        let stepInitial: WizardStep;
        /** Inicializamos las opciones del Wizard (librería Slide) */
        stepInitial = this.wizardStepQuery.getEntity(
            IdsStepsTreatmentWizardModel.FAMILIES
        );
        this.slideOpts = {
            initialSlide: stepInitial.id,
            speed: 200,
            allowTouchMove: false,
        };
        Object.assign(this.swiperContainer?.nativeElement, this.slideOpts);
        this.swiperContainer.nativeElement?.initialize();

        this.goToInitStep(stepInitial);
    }

    /*------------------------------------------*/
    /** INSTRUCCIONES PARA CREAR UN PASO NUEVO
     * Para crear un paso nuevo, los requisitos son los siguientes:
     * Cada paso tiene que ser añadido al objeto de configuración de pasos, indicando su número de paso y su título de paso.
     * Cada paso tiene que tener una función inicializadora del paso,otra que lo destruya y otra que deshará
     * la acción de ir al siguiente paso.
     * En estas funciones pondremos las acciones que necesitamos hacer cuando se entra a ese paso (inicialización)
     * en concreto y lo que hay que hacer cuando se vuelve de ese paso en concreto (limpieza)
     /*------------------------------------------*/

    /*--------------------*/
    /** PASO 0: FAMILIAS  */

    /*--------------------*/

    initFamilyStep() {
        this.slideActiveIndex = 0;
        setTimeout(() => {
            this.addScrollEventListenerToSlide(this.slideActiveIndex);
        }, 100);

        /** Se inicia el observable de los servicios selecionados por el usuario */
        this.productsWithUnits$ = this.productWizardQuery.selectAll({
            filterBy: ({ unitsCart }) => unitsCart > 0,
        });
        this.paymethodsWizard$ = this.paymethodWizardQuery.selectAll();
    }

    /** Paso de familias del asistente. Hemos pulsado una familia */
    onFamilyClicked(family: FamilyFolderModel) {
        this.familyFolderUserAction$.next(true);
        this.resetFamilySearchbar();
        this.slideActiveIndex++;
        this.addScrollEventListenerToSlide(this.slideActiveIndex);
        this.familyFolderSlide[this.slideActiveIndex] = { ...family };
        this.familyFolderSlideFiltered[this.slideActiveIndex] = family;
        this.swiperContainer?.nativeElement.swiper.slideTo(this.slideActiveIndex);
    }

    popFamilyFolder() {
        this.resetFamilySearchbar();
        this.removeScrollEventListenerToSlide(this.slideActiveIndex);
        this.slideActiveIndex--;
        this.swiperContainer?.nativeElement.swiper.slideTo(this.slideActiveIndex);
    }

    addScrollEventListenerToSlide(slideActiveIndex) {
        this.productsLength = 15;
        this.swiperContainer?.nativeElement.swiper.slides[slideActiveIndex].scrollTo(0, 0);
        this.swiperContainer?.nativeElement.swiper.slides[slideActiveIndex].addEventListener(
            'scroll',
            this.onScroll,
            false
        );
           
    }

    removeScrollEventListenerToSlide(slideActiveIndex) {
        this.productsLength = 15;
        this.swiperContainer?.nativeElement.swiper.slides[slideActiveIndex].scrollTo(0, 0);
        this.swiperContainer?.nativeElement.swiper.slides[slideActiveIndex].removeEventListener(
            'scroll',
            this.onScroll,
            false
        );
        
    }

    resetFamilySearchbar() {
        if (this.serviceSearchBar) {
            this.serviceSearchBar.clearInput();
        }

        if (this.genericHeader) {
            this.genericHeader.clearInput();
        }

        this.onChangeFamilySearchbar('');
    }

    familyUndoNextStep() {
        this.slideActiveIndex = 0;
        this.resetFamilySearchbar();
    }

    /** TODO: Hacerla función obligatoria de los pasos para poder llamar a esta función en todos */
    familyNextStep() {
        /** El próximo paso de Families es Métodos de pago */
        this.goToNextStep(IdsStepsTreatmentWizardModel.PAYMETHODS);
    }

    destroyFamilyStep() {}

    /** A partir del Observable de los familias se aplica un filtro de búsqueda del buscador */
    onChangeFamilySearchbar(searchText: string) {
        if (!this.familyFolderSlide[this.slideActiveIndex]) {
            return;
        }

        this.productsLength = 15;
        this.swiperContainer?.nativeElement.swiper.slides[this.slideActiveIndex].scrollTo(0, 0);
    
        const familiesFiltered = this.familyFolderSlide[
            this.slideActiveIndex
        ].families.filter((family) => {
            return family.description
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .includes(
                    searchText
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                );
        });

        const productsFiltered = this.familyFolderSlide[
            this.slideActiveIndex
        ].products.filter((product) => {
            return (
                product.description
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(
                        searchText
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                    ) ||
                product.clinicName
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(
                        searchText
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                    )
            );
        });

        this.familyFolderSlideFiltered[
            this.slideActiveIndex
        ].families = familiesFiltered;
        this.familyFolderSlideFiltered[
            this.slideActiveIndex
        ].products = productsFiltered;
    }

    familyActionButtonDisabled(): Observable<boolean> {
        return this.productsWithUnits$.pipe(
            map((productsWithUnits) => {
                console.log(productsWithUnits);
                return productsWithUnits.length <= 0;
            })
        );
    }

    get countFamiliesAndProducts() {
        return (
            this.familyFolderSlide[this.slideActiveIndex].families.length +
            this.familyFolderSlide[this.slideActiveIndex].products.length
        );
    }

    onScroll = (e): void => {
        const target = event.target as HTMLDivElement;
        const scrollBottom =
            target.scrollHeight -
            (target.scrollTop + target.getBoundingClientRect().height);

        if (scrollBottom < 200) {
            this.productsLength += 15;
        }
    };

    async onProductToggle(
        productWizardCheckedEvent: ProductWizardCheckedEvent
    ) {
        this.familyFolderUserAction$.next(true);
        this.productWizardService.setUnitsCart(
            productWizardCheckedEvent.product.id,
            productWizardCheckedEvent.newUnits
        );
    }

    async onProductClickToPresentModal(productWizard: ProductWizard) {
        this.familyFolderUserAction$.next(true);
        this.presentModalProductView(productWizard.id);
    }

    async presentModalProductView(productId) {
        this.familyFolderUserAction$.next(true);
        const modal = await this.modalController.create({
            component: ProductViewComponent,
            cssClass: this.settingsQuery.browser ? 'modal-flowwwer modal-browser' : 'modal-flowwwer',
            componentProps: {
                productId,
            },
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data?.confirmed) {
                this.productWizardService.setUnitsCart(
                    productId,
                    dataReturned.data?.currentUnits
                );
            }
        });

        return await modal.present();
    }

    /** Flowwwer template */
    onProductClick(product: ProductWizard) {
        this.familyFolderUserAction$.next(true);
        this.productWizardService.toggleProductChecked(product.id);
    }

    /*--------------------------------------*/
    /** PASO 2: Listado métodos de pago --- */

    /*--------------------------------------*/

    initPaymethodStep() {
        this.paymethodsChecked$ = this.paymethodWizardQuery.selectAll({
            filterBy: ({ checked }) => checked === true,
        });

        this.shippingConfigConponent.canEditShippingAddress = false;
    }

    //TODO. Por qué hay 3 eventos muy parecidos si con 1 solo basta?
    //Y por que los 3 metodos ponen a checked el método de pago? solo debería hacer falta
    //si estamos en el listado con checkboxes (como en appointments)
    async onPaymethodChecked(
        paymethodWizardCheckedEvent: PaymethodWizardCheckedEvent
    ) {
        this.paymethodWizardService.setPaymethodChecked(
            paymethodWizardCheckedEvent.paymethod.id,
            paymethodWizardCheckedEvent.checkedEvent
        );

        if (paymethodWizardCheckedEvent.checkedEvent) {
            this.paymethodWizardService.setActive(
                paymethodWizardCheckedEvent.paymethod.id
            );

            /** TODO: ver como hacerlo mejor */
            /** Esperamos a que Akita marque como activo el método de pago para continuar */
            await this.paymethodWizardQuery.selectActive().pipe(
                filter((data) => data !== null && data !== undefined),
                take(1)
            );
        } else {
            this.paymethodWizardService.setActive(null);
        }
    }

    async onPaymethodToggle(paymethodWizard: PaymethodWizard) {
        const checked = !this.paymethodWizardQuery.getEntity(paymethodWizard.id)
            .checked;

        this.paymethodWizardService.togglePaymethodChecked(paymethodWizard.id);

        if (checked) {
            this.paymethodWizardService.setActive(paymethodWizard.id);

            /** TODO: ver como hacerlo mejor */
            /** Esperamos a que Akita marque como activo el método de pago para continuar */
            await this.paymethodWizardQuery.selectActive().pipe(
                filter((data) => data !== null && data !== undefined),
                take(1)
            );
        } else {
            this.paymethodWizardService.setActive(null);
        }
    }

    async onPaymethodClicked(paymethodWizard: PaymethodWizard) {
        this.paymethodWizardService.setPaymethodChecked(
            paymethodWizard.id,
            true
        );

        this.paymethodWizardService.setActive(paymethodWizard.id);

        /** TODO: ver como hacerlo mejor */
        /** Esperamos a que Akita marque como activo el método de pago para continuar */
        await this.paymethodWizardQuery.selectActive().pipe(
            filter((data) => data !== null && data !== undefined),
            take(1)
        );
        this.actionNextStep();
    }

    paymethodNextStep() {
        this.paymentWizardSettingsService.createUrlPaymentByTreatment();
        this.goToNextStep(IdsStepsTreatmentWizardModel.PAYMENT);
    }

    paymethodUndoNextStep() {
        templatePaymethodUndoNextStep({
            defaultTemplate: this.paymethodUndoNextStepDefault,
            flowwwerTemplate: this.paymethodUndoNextStepFlowwwer,
        });
    }

    paymethodUndoNextStepDefault = () => {
        /** Si estamos en modo listado, deshacemos la selección del método de pago */
        if (this.treatmentWizardSettingsQuery.shippingEnabled === 0) {
            this.paymethodWizardService.setActive(null);
            this.paymethodWizardService.resetPaymethodChecked();
        }
    };

    paymethodUndoNextStepFlowwwer = () => {};

    destroyPaymethodStep() {
        this.paymethodWizardService.setActive(null);
        this.paymethodWizardService.resetPaymethodChecked();

        this.treatmentWizardSettingsService.updateConfirmShippingUserChecked(
            false
        );

        this.treatmentWizardSettingsService.updateCancelShippingUserChecked(
            false
        );
    }

    /** Flowwwer template */
    paymethodsActionButtonDisabled(): Observable<boolean> {
        return templatePaymethodsActionButtonDisabled({
            defaultTemplate: this.paymethodsActionButtonDisabledDefault,
            flowwwerTemplate: this
                .paymethodsActionButtonDisabledDefaultFlowwwer,
        });
    }

    paymethodsActionButtonDisabledDefault = (): Observable<boolean> => {
        return combineLatest([
            this.paymethodsChecked$,
            this.treatmentWizardSettings$,
        ]).pipe(
            map(([paymethods, treatmentWizardSettings]) => {
                if (
                    paymethods.length > 0 &&
                    ((treatmentWizardSettings.shippingEnabled === -1 &&
                        (treatmentWizardSettings.cancelShippingUserChecked ||
                            treatmentWizardSettings.confirmShippingUserChecked)) ||
                        treatmentWizardSettings.shippingEnabled !== -1)
                ) {
                    return false;
                } else {
                    return true;
                }
            })
        );
    };

    //Es el mismo para default?
    paymethodsActionButtonDisabledDefaultFlowwwer = (): Observable<boolean> => {
        return combineLatest([
            this.paymethodsChecked$,
            this.treatmentWizardSettings$,
        ]).pipe(
            map(([paymethods, treatmentWizardSettings]) => {
                if (
                    paymethods.length > 0 &&
                    ((treatmentWizardSettings.shippingEnabled === -1 &&
                        (treatmentWizardSettings.cancelShippingUserChecked ||
                            treatmentWizardSettings.confirmShippingUserChecked)) ||
                        treatmentWizardSettings.shippingEnabled !== -1)
                ) {
                    return false;
                } else {
                    return true;
                }
            })
        );
    };

    onChangeCancelShipping(checked: boolean) {
        this.treatmentWizardSettingsService.updateCancelShippingUserChecked(
            checked
        );
        if (checked) {
            this.treatmentWizardSettingsService.updateConfirmShippingUserChecked(
                false
            );
        }
    }

    onCchangeConfirmShipping(checked: boolean) {
        this.treatmentWizardSettingsService.updateConfirmShippingUserChecked(
            checked
        );
        if (checked) {
            this.treatmentWizardSettingsService.updateCancelShippingUserChecked(
                false
            );
        }
    }

    onUpdateShippingAddress(shippingAddress: string) {
        this.treatmentWizardSettingsService.updateShippingAddress(
            shippingAddress
        );
    }

    /** Flowwwer template */
    payMethodStepCheckShowActionButton(): Observable<boolean> {
        return templatePayMethodStepCheckShowActionButton({
            defaultTemplate: this.payMethodStepCheckShowActionButtonDefault,
            flowwwerTemplate: this.payMethodStepCheckShowActionButtonFlowwwer,
        });
    }

    payMethodStepCheckShowActionButtonDefault = () => {
        if (this.treatmentWizardSettingsQuery.shippingEnabled === 0) {
            return of(false);
        } else {
            return of(true);
        }
    };

    payMethodStepCheckShowActionButtonFlowwwer = (): Observable<boolean> => {
        return of(true);
    };

    /*--------------------------------------*/
    /** PASO 3: Pago en proceso------------ */

    /*--------------------------------------*/

    initPaymentStep() {
        const paymethodActive: PaymethodWizard = this.paymethodWizardQuery.getActive();
        this.urlPaymentSafe$ = this.paymentWizardSettingsQuery.selectUrlPaymentSafe();

        /** Creamos un listener para escuchar las respuestas de los iframes de pago */
        window.addEventListener(
            'message',
            (this.listenerEventsPayment = (event) => {
                switch (event.data) {
                    /** Pago OK de cualquier método. Realizar la compra */
                    case paymethodActive.url_ok: {
                        this.ngZone.run(() => {
                            this.completeWizard();
                        });

                        window.removeEventListener(
                            'message',
                            this.listenerEventsPayment
                        );
                        break;
                    }

                    case paymethodActive.url_err: {
                        this.showAlertErrorPay(
                            this.libraryService.getLabel('app_buy_step_4b_desc')
                        );
                        this.ngZone.run(() => {
                            this.goToPrevStep();
                        });

                        window.removeEventListener(
                            'message',
                            this.listenerEventsPayment
                        );
                        break;
                    }
                }
            })
        );
    }

    async showAlertErrorPay(message: string) {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            message,
            buttons: [
                {
                    text: 'OK',
                    role: 'ok',
                },
            ],
        });
        await alert.present();
    }

    completeWizard() {
        this.goToNextStep(IdsStepsTreatmentWizardModel.RESULT);
    }

    /** No tiene siguiente paso */
    paymentNextStep() {}

    /** No hay que hacer un undo del siguiente paso porque no tiene */
    paymentUndoNextStep() {}

    destroyPaymentStep() {
        this.paymentWizardSettingsService.resetUrlPayment();
        window.removeEventListener('message', this.listenerEventsPayment);
    }

    /*--------------------------------------*/
    /** PASO 4: Resultado del asistente---- */

    /*--------------------------------------*/
    initResultStep() {
        this.treatmentService.getTreatments();
        try {
            this.userService.checkUserAndLoad(true);
            if (this.companyQuery.clientAdvisor) {
                this.userService.getReferrerData();
            }
        } catch (e) {
            this.routerService.goToMainTabWithoutLogin();
        }

        /** Borramos toda la pila del asistente, puesto que este es el último paso y solo se podrá cerrar */
        this.treatmentWizardSettingsService.clearStepStack();
    }

    resultNextStep() {
        this.dismissModal();
    }

    resultUndoNextStep() {}

    destroyResultStep() {}

    /** Flowwwer template */
    resultStepCheckShowActionButton(): Observable<boolean> {
        return templateResultStepCheckShowActionButton({
            defaultTemplate: this.resultStepCheckShowActionButtonDefault,
            flowwwerTemplate: this.resultStepCheckShowActionButtonFlowwwer,
        });
    }

    resultStepCheckShowActionButtonDefault = () => {
        return of(false);
    };

    resultStepCheckShowActionButtonFlowwwer = (): Observable<boolean> => {
        return of(true);
    };

    /*---------------------------*/
    /** DESTRUIR MODAL ASISTENTE */

    /*---------------------------*/

    ngOnDestroy(): void {
        this.treatmentWizardSettingsService.resetStore();
        this.productWizardService.resetStore();
        this.wizardStepService.resetStore();
        this.paymethodWizardService.resetStore();
        this.paymentWizardSettingsService.resetStore();
        window.removeEventListener('message', this.listenerEventsPayment);
    }
}
